import { render, staticRenderFns } from "./catalog-item-info-modal.vue?vue&type=template&id=705ee421&scoped=true&"
import script from "./catalog-item-info-modal.vue?vue&type=script&lang=js&"
export * from "./catalog-item-info-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "705ee421",
  null
  
)

export default component.exports